import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {H2} from '@jetbrains/ring-ui/components/heading/heading'
import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import plur from 'plur'
import {memo} from 'react'

import {restApi} from '../../../../../services/rest'
import {emptyArray} from '../../../../../utils/empty'
import {getTestOccurrenceMetadataArg} from '../../Tests.rest'

import TestMetadataItem from './TestMetadataItem'
import type {Props} from './TestMetadataPopup.types'

import styles from './TestMetadataPopup.css'

function TestMetadataPopup({
  buildTypeId,
  buildId,
  testName,
  isProcessing,
  closeDialog,
  showTestMetadataGraphHandler,
  testOccurrenceId,
}: Props) {
  const {metadataList, isReady} = restApi.endpoints.getTestOccurrence.useQuery(
    getTestOccurrenceMetadataArg(testOccurrenceId),
    {
      selectFromResult: ({data}) => ({
        metadataList: data?.metadata?.typedValues ?? emptyArray,
        isReady: data != null,
      }),
    },
  )

  const title = `${metadataList.length} Metadata ${plur('attachment', metadataList.length)}`
  return (
    <div>
      <Dialog
        label={title}
        className={styles.overlay}
        contentClassName={styles.dialog}
        autoFocusFirst={false}
        showCloseButton={!isProcessing}
        onCloseAttempt={isProcessing ? undefined : closeDialog}
        show
        trapFocus
      >
        <div className={styles.wrapper}>
          <div className={styles.header}>
            <H2 className={styles.heading}>{title}</H2>
            {testName != null && <span>{`Test: ${testName}`}</span>}
          </div>
          <div className={styles.content}>
            {isReady ? (
              metadataList.map(metadata => (
                <div className={styles.item} key={metadata.name}>
                  <TestMetadataItem
                    buildTypeId={buildTypeId}
                    buildId={buildId}
                    metadata={metadata}
                    showTestMetadataGraph={showTestMetadataGraphHandler}
                    withBoldValue
                  />
                </div>
              ))
            ) : (
              <LoaderInline>{'Loading...'}</LoaderInline>
            )}
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default memo(TestMetadataPopup)
